<template>
  <div
    class="infoBar"
    :class="[
      'infoBar',
      `infoBar--${layout}`,
      {
        'infoBar--disablePaddings': disablePaddings,
      },
    ]"
  >
    <div
      :class="[
        'infoBar__inner',
        {
          'infoBar__closeButton--withClose': withClose,
        },
      ]"
    >
      <span :class="['infoBar__icon', `icon-${icon}`]" :style="`color: ${color}`" />
      <span class="infoBar__message" v-html="cleanHtml" />
      <span
        :class="['infoBar__closeButton', { 'infoBar__closeButton--visible': withClose }]"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBar',
  props: {
    message: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    layout: {
      type: String,
      default: 'dark',
    },
    withClose: {
      type: Boolean,
      default: true,
    },
    disablePaddings: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cleanHtml() {
      return this.message;
      // return this.$sanitize(this.message);
    },
  },
};
</script>

<style lang="scss">
.infoBar {
  $root: &;
  border-radius: 0.4rem;
  padding-left: 2.5rem;
  width: 100%;
  position: relative;
  min-height: 5.5rem;

  &__inner {
    position: relative;
    display: flex;
    background-color: $cBg;
    width: 100%;
    height: 100%;
    min-height: 5.5rem;
    border-radius: 5px;
    padding: 1.4rem 3rem 1.4rem 4.5rem;

    &--withClose {
      padding: 1.4rem 5.5rem 1.4rem 4.5rem;
    }
  }

  &__icon {
    width: 5.5rem;
    height: 5.5rem;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(calc(-50% + 3px));
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $cWhite;
    border-radius: 50%;
    border: 1px solid $cAddLight;
    font-size: 2.9rem;

    &--success {
      &::before {
        @include icomoon('check-border');
        font-size: 2.9rem;
        color: $cSec;
      }
    }

    &--error {
      &::before {
        @include icomoon('wrong');
        font-size: 2.9rem;
        color: $cBadgeProm;
      }
    }

    &--warning {
      &:before {
        @include icomoon('warning');
        font-size: 2.8rem;
        color: $cSec;
      }
    }
  }

  &__message {
    width: 100%;
    font-size: 1.6rem;
    line-height: 2.6rem;
    color: $cMainDark;
    overflow: hidden;

    b {
      color: $cMain;
      font-weight: 700;
    }
  }

  &__closeButton {
    display: none;
    position: absolute;
    right: 5px;
    top: 0;
    padding: 1.3rem 1.5rem;
    font-size: 1.2rem;
    line-height: 2.6rem;
    color: $cAddDark02;
    margin-left: auto;
    cursor: pointer;

    &:before {
      @include icomoon('line-close');
    }

    &--visible {
      display: block;
    }
  }

  &--light {
    #{$root}__inner {
      background-color: $cWhite;
      border: 1px solid $cAddLight;
    }
  }

  &--disablePaddings {
    #{$root}__inner {
      padding: 0 2rem 0 4.5rem;
    }
  }
}
</style>
